// When the picture of one casino result comes to rest (R2115).
//
// The wheel and the reels move for a span after the result frame lands.
// The screens, the visit net and the result cue all wait for the same
// moment, so the two functions live here, in the casino chunk of the
// build. `resultcue.ts` re-exports them for the map feed, and the build
// edge then runs from the main chunk to the casino chunk only (R1432).

import {
  CASINO_REEL_MS, CASINO_REEL_STAGGER_MS, CASINO_WHEEL_MS,
} from '../../gen/presentation';
import { CasinoGame, type CasinoResult } from '../../gen/proto/aquaphobia';

/** How long the picture of a result takes to come to rest, in ms. The
 *  card games draw their verdict at once. */
export function landingMs(r: CasinoResult, still: boolean): number {
  if (still) return 0;
  switch (r.game) {
    case CasinoGame.CASINO_GAME_ROULETTE: return CASINO_WHEEL_MS;
    case CasinoGame.CASINO_GAME_SLOTS:
      return CASINO_REEL_MS + CASINO_REEL_STAGGER_MS * Math.max(0, r.reels.length - 1);
    default: return 0;
  }
}

/**
 * True once the picture of `r` came to rest (R2115): `landingMs` after
 * `startMs`, the first render pass that drew the result. The verdict of a
 * screen, the win flash and the visit net all wait for this moment, and
 * the cue below waits for the same span from the frame's arrival.
 */
export function hasLanded(r: CasinoResult, still: boolean, nowMs: number, startMs: number): boolean {
  return nowMs - startMs >= landingMs(r, still);
}
